var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10665 8C3.77194 10.7537 5.74194 12 8.00008 12C10.2582 12 12.2282 10.7537 13.8935 8C12.2282 5.24632 10.2582 4 8.00008 4C5.74194 4 3.77194 5.24632 2.10665 8ZM0.754594 7.66923C2.60488 4.4314 5.01341 2.66667 8.00008 2.66667C10.9868 2.66667 13.3953 4.4314 15.2456 7.66923C15.3627 7.87419 15.3627 8.12581 15.2456 8.33077C13.3953 11.5686 10.9868 13.3333 8.00008 13.3333C5.01341 13.3333 2.60488 11.5686 0.754594 8.33077C0.637466 8.12581 0.637466 7.87419 0.754594 7.66923ZM8.00008 7.33333C7.63189 7.33333 7.33341 7.63181 7.33341 8C7.33341 8.36819 7.63189 8.66667 8.00008 8.66667C8.36827 8.66667 8.66675 8.36819 8.66675 8C8.66675 7.63181 8.36827 7.33333 8.00008 7.33333ZM6.00008 8C6.00008 6.89543 6.89551 6 8.00008 6C9.10465 6 10.0001 6.89543 10.0001 8C10.0001 9.10457 9.10465 10 8.00008 10C6.89551 10 6.00008 9.10457 6.00008 8Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9bf7d392ea5e0fcf0f0ca47f51045a20.svg";
export { ForwardRef as ReactComponent };